// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_FormatDataRowPreview {
  max-height: 12em;
  min-height: 6em;
  border: 1px solid #808080;
  overflow: scroll;
}
.CSVImporter_FormatDataRowPreview__table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}
.CSVImporter_FormatDataRowPreview__table > thead > tr > th {
  font-style: italic;
  font-weight: normal;
  color: #808080;
}
.CSVImporter_FormatDataRowPreview__table > thead > tr > th,
.CSVImporter_FormatDataRowPreview__table > tbody > tr > td {
  border-right: 1px solid rgba(128, 128, 128, 0.5);
  padding: 0.5em 0.5em;
  line-height: 1;
  font-size: 0.75em;
  white-space: nowrap;
}
.CSVImporter_FormatDataRowPreview__table > thead > tr > th:last-child,
.CSVImporter_FormatDataRowPreview__table > tbody > tr > td:last-child {
  border-right: none;
}
.CSVImporter_FormatDataRowPreview__table > thead + tbody > tr:first-child > td,
.CSVImporter_FormatDataRowPreview__table > tbody > tr + tr > td {
  padding-top: 0;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/file-step/FormatDataRowPreview.scss","webpack://./theme.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AADF;AAGE;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;AADJ;AAGI;EACE,kBAAA;EACA,mBAAA;EACA,cCPe;ADMrB;AAII;;EAEE,gDAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAFN;AAIM;;EACE,kBAAA;AADR;AAMI;;EAEE,cAAA;AAJN","sourcesContent":["@import '../../../theme.scss';\n\n.CSVImporter_FormatDataRowPreview {\n  max-height: 12em;\n  min-height: 6em;\n  border: 1px solid $controlBorderColor;\n  overflow: scroll;\n\n  &__table {\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse;\n\n    > thead > tr > th {\n      font-style: italic;\n      font-weight: normal;\n      color: $textSecondaryColor;\n    }\n\n    > thead > tr > th,\n    > tbody > tr > td {\n      border-right: 1px solid rgba($controlBorderColor, 0.5);\n      padding: 0.5em 0.5em;\n      line-height: 1;\n      font-size: 0.75em;\n      white-space: nowrap;\n\n      &:last-child {\n        border-right: none;\n      }\n    }\n\n    // shrink space between rows\n    > thead + tbody > tr:first-child > td,\n    > tbody > tr + tr > td {\n      padding-top: 0;\n    }\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
